import { Video, LayoutGrid, List, LogOut, RefreshCw } from 'lucide-react';
import styles from './Header.module.css';

interface HeaderProps {
  currentPage?: 'cameras' | 'grid';
  onNavigate?: (page: 'cameras' | 'grid') => void;
  onLogout?: () => void;
  onRefresh?: () => void;
}

export function Header({
  currentPage = 'cameras',
  onNavigate,
  onLogout,
  onRefresh
}: HeaderProps) {
  return (
    <header className={styles.header}>
      <div className={styles.logoSection}>
        <div className={styles.logoIcon}>
          <Video size={20} />
        </div>
        <span className={styles.logoText}>VidWatch</span>
      </div>

      {onNavigate && (
        <nav className={styles.nav}>
          <button
            className={`${styles.navLink} ${currentPage === 'cameras' ? styles.navLinkActive : ''}`}
            onClick={() => onNavigate('cameras')}
          >
            <List size={18} />
            Список
          </button>
          <button
            className={`${styles.navLink} ${currentPage === 'grid' ? styles.navLinkActive : ''}`}
            onClick={() => onNavigate('grid')}
          >
            <LayoutGrid size={18} />
            Сетка
          </button>
        </nav>
      )}

      <div className={styles.actions}>
        {onRefresh && (
          <button 
            className={styles.refreshButton} 
            onClick={onRefresh}
            title="Обновить данные"
          >
            <RefreshCw size={18} />
          </button>
        )}
        {onLogout && (
          <button className={styles.exitButton} onClick={onLogout}>
            <LogOut size={18} />
            Выйти
          </button>
        )}
      </div>
    </header>
  );
}
